import { render, staticRenderFns } from "./ResourceAdmin.vue?vue&type=template&id=8a339f4e&scoped=true&"
import script from "./ResourceAdmin.vue?vue&type=script&lang=js&"
export * from "./ResourceAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a339f4e",
  null
  
)

export default component.exports